import "core-js/modules/es6.array.map.js";
import Loan from "../../models/Loan";
export var setLoans = function setLoans(state, payload) {
  state.loans = payload.map(function (loan) {
    return new Loan(loan);
  });
};
export var reset = function reset(state) {
  state.loans = null;
};